const detailscontacts = (state = [], action) => {
  switch (action.type) {
    case "DETAILSCONTACTS":
      return {
        type: "DETAILSCONTACTS",
        detailsget: action.detailsget,
        detailscontacts: action.detailscontacts,
        detailsatend: action.detailsatend,
        contactAdd: action.contactAdd,
      };
    default:
      return state;
  }
};

export default detailscontacts;
